import { Config } from "./Config";
import axios, { AxiosError } from "axios";

const baseURL = Config.ROOT_URL + "api/";

const axiosConfig = {
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  }};

const defaultHeaders = axiosConfig.headers;

axios.interceptors.request.use(
  function (config) {
    // document.body.classList.add("loading-indicator");
    return config;
  },
  function (error) {
    // document.body.classList.remove("loading-indicator");
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    // document.body.classList.remove("loading-indicator");
    return response;
  },
  function (error) {
    // document.body.classList.remove("loading-indicator");
    return Promise.reject(error);
  }
);
export default class Api {
  static setDefaults() {
    const d = axios.defaults;
    d.baseURL = baseURL;
    this.transformResponse();
  }

  static transformResponse() {
    return {
      transformResponse: [
        (data: any) => {
          return data ? JSON.parse(data) : {};
        },
      ],
    };
  }

  static handleStatus(callback: Function, response: any) {
    const result = response;
    if (response.status !== 200) {
      this.handleException(response, callback);
    } else {
      this.handleResponse(callback, result.data);
    }
  }

  static handleResponse(callback: Function, response: any) {
    callback(response);
  }

  static handleException(ex: any, callback: Function) {
    console.log(ex);
    callback(ex.response?.data);
  }

  static async get(api: string, callback: Function) {
    await axios
      .get(baseURL + api, {
        headers: defaultHeaders,
      })
      .then((response) => {
        this.handleStatus(callback, response);
      })
      .catch((ex) => {
        this.handleException(ex, callback);
      });
  }

  
static async post(api: string, params: any, callback: Function) {
  const url = baseURL + api;

  const postConfig = {
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
  withCredentials: false,
  // withCredentials: false, // keep false unless you use cookies
  timeout: 30000,
};
  

  try {
    const response = await axios.post(url, params, postConfig);
    this.handleStatus(callback, response);
    return response;
  } catch (err: unknown) {
    const e = err as AxiosError<any>;

    // Build a very explicit debug message
    const debug = {
      url,
      method: "POST",
      message: (e as any)?.message,
      code: (e as any)?.code,
      // present when server replied (4xx/5xx)
      status: e.response?.status,
      statusText: (e.response as any)?.statusText,
      responseData: e.response?.data,
      // present when request was made but no response (CORS/TLS/DNS/proxy)
      hasRequest: !!e.request,
      // what we tried to send
      requestHeaders: (e.config as any)?.headers,
      timeout: (e.config as any)?.timeout,
      withCredentials: (e.config as any)?.withCredentials,
    };

    console.error("API POST FAILED:", debug);

    // Pass something useful back to your existing UI flow
    callback({
      UserId: null,
      Message:
        e.response
          ? `Server error (${e.response.status}): ${
              e.response.data?.Message ?? e.message
            }`
          : `Network error: ${e.message || "Request blocked (CORS/TLS/DNS)"}`
    });

    // If you already have centralized handling, call it too:
    // this.handleException(e, callback);

    return null;
  }
}

  static async put(api: string, params: object, callback: Function) {
    await axios
      .put(api, params, {
        headers: defaultHeaders,
      })
      .then((response) => {
        this.handleStatus(callback, response);
      })
      .catch((ex) => {
        this.handleException(ex, callback);
      });
  }

  static async delete(api: string, params: object, callback: Function) {
    await axios
      .delete(api, {
        headers: defaultHeaders,
      })
      .then((response) => {
        this.handleStatus(callback, response);
      })
      .catch((ex) => {
        this.handleException(ex, callback);
      });
  }
}
